// eslint-disable-next-line no-undef
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:10000/';
